import {
  createErrorOperationResult,
  createSuccessOperationResult,
} from '@hc-frontend/core-utils-business-operation';

import type { MoveToStartPlateRepository } from '../../domain/repositories/move-to-start-plate-repository';
import { journeyAliasToPath } from '../move-to-plate-adapter/journey-alias-to-path';

export function moveToStartPlateAdapterFactory(): MoveToStartPlateRepository {
  return {
    moveToStartPlate: async ({ journeyAlias, plate }) => {
      try {
        const { headers } = await import('next/headers');

        const requestUrl = headers().get('x-url');

        let searchParams = requestUrl
          ? new URL(requestUrl).searchParams
          : undefined;

        // MP-928
        if (searchParams) {
          searchParams = new URLSearchParams(
            Array.from(searchParams).filter(([key]) => key !== 'redirect'),
          );
        }

        const url = `/${journeyAliasToPath[journeyAlias]}/${plate?.pathname ?? ''}`;

        return createSuccessOperationResult({
          url,
          searchParams: searchParams?.toString(),
        });
      } catch (error) {
        return createErrorOperationResult({
          errors: [
            { code: 'failedToMoveToStartPlate', rootCause: error as Error },
          ],
        });
      }
    },
  };
}
